module.exports = __webpack_public_path__ + "img/us_soccer_insider.c3efbfea.png";